interface Props {
  label?: string;
}

export function LoadingPlaceholder({ label = 'Loading…' }: Props) {
  return (
    <div className="text-center text-muted" style={{ padding: 40 }}>
      <i className="fas fa-spinner fa-spin fa-2x" aria-hidden="true" />
      <p style={{ marginTop: 10 }}>{label}</p>
    </div>
  );
}
